/**
 * 同一ページ内アンカーリンクのスムーススクロール
 * jQuery は BaseLayout で読み込み済みの前提
 */
function getDefaultScrollOffset() {
	const container = document.querySelector('.l-container');
	if (container) {
		const marginTop = parseFloat(getComputedStyle(container).marginTop);
		if (!Number.isNaN(marginTop) && marginTop > 0) return marginTop;
	}
	if (window.matchMedia('(min-width:768px)').matches) return 108;
	return Math.round((window.innerWidth * 120) / 390);
}

function getScrollOffset(el) {
	if (!el) return getDefaultScrollOffset();
	const scrollMarginTop = parseFloat(getComputedStyle(el).scrollMarginTop);
	if (!Number.isNaN(scrollMarginTop) && scrollMarginTop > 0) return scrollMarginTop;
	return getDefaultScrollOffset();
}

export function init() {
	if (typeof window.$ === 'undefined') return;
	const $ = window.$;
	$(window).on('load', function () {
		$('a[href*="#"], area[href*="#"]').on('click', function () {
			const speed = 500;
			const href = $(this).attr('href');
			const target = $(href === '#' || href === '' ? 'html' : href);
			const el = target[0];
			const offset = getScrollOffset(el);
			const position = target.offset().top - offset;
			$('html, body').animate({ scrollTop: position }, speed, 'swing');
			return false;
		});
	});
}
